<script>
import ListNotificationsComponent from '../../features/Lists/ListNotificationsComponent';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  extends: ListNotificationsComponent,
  components: {
    'page-header-view': PageHeaderView,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <!-- Body Start -->
  <div class="wrapper">
    <div class="sa4d25">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <page-header-view
              icon="fas fa-bell"
              title="Notificaciones"
              subtitle="Avisos, respuestas de actividades y mensajes dirigidos a la comunidad"
            />
          </div>
        </div>
        <el-table
          v-loading="isListLoading"
          :data="collection"
          empty-text="No se encontraron resultados."
          element-loading-spinner="el-icon-loading"
          :element-loading-text="listLoadingMessage"
        >
          <el-table-column
            label=""
            width="70"
          >
            <template #default="scope">
              <div>
                <el-avatar :src="mapImage(scope.row.sender)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="ENVIA"
            width="250"
          >
            <template #default="scope">
              <div v-if="scope.row.sender">
                {{ scope.row.sender.firstName }} {{ scope.row.sender.lastName }}
              </div>
              <div v-else>
                APPMISIONATE PLATAFORMA
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="70"
          >
            <template #default="scope">
              <div>
                <el-avatar :src="mapImage(scope.row.receiver)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="RECIBE"
            width="250"
          >
            <template #default="scope">
              <div v-if="scope.row.receiver">
                {{ scope.row.receiver.firstName }} {{ scope.row.receiver.lastName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="MENSAJE"
            min-width="220"
          >
            <template #default="scope">
              <div>
                {{ scope.row.message }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="ESTADO"
            width="90"
            align="center"
          >
            <template #default="scope">
              <el-tag
                v-if="!scope.row.isRead"
                type="info"
                effect="plain"
              >
                Nuevo
              </el-tag>
              <el-tag
                v-if="scope.row.isRead"
                type="info"
                effect="plain"
              >
                Leido
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="CREACIÓN"
            :width="140"
            align="center"
          >
            <template #default="scope">
              <el-tag
                type="info"
                effect="plain"
              >
                <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="updatedAt"
            label="ACTUALIZACIÓN"
            :width="140"
            align="center"
          >
            <template #default="scope">
              <el-tag
                v-if="onCheckUpdatedAt(scope.row.updatedAt)"
                type="info"
                effect="plain"
              >
                <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
        label="OPCIONES"
        :width="140"
        align="center"
        text-align="center"
      >
        <template slot-scope="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
              <el-dropdown-item
                :command="{ command: 'edit', item: scope.row }"
                :disabled="!onCanRead(modulePermissions)"
              >
                <i class="el-icon-edit" aria-hidden="true"></i> Mostrar
              </el-dropdown-item>
              <el-dropdown-item
                :command="{ command: 'delete', item: scope.row }"
                :disabled="!onCanDelete(modulePermissions)"
              >
                <i class="el-icon-delete" aria-hidden="true"></i> Eliminar
              </el-dropdown-item>
            </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column> -->
        </el-table>
        <el-pagination
          v-model:current-page="currentPage"
          size="small"
          layout="prev, pager, next"
          :page-count="pagination.totalPages"
          @current-change="onPageChange"
        />
      </div>
    </div>
  </div>
  <!-- Body End -->
</template>
